/**
 * Formats text content by replacing literal "/n" with actual newlines
 * and handling other common text formatting issues
 */
export const formatTextContent = (text: string | null | undefined): string => {
  if (!text) return '';
  
  // Replace literal "/n" with actual newlines
  return text.replace(/\/n/g, '\n');
}; 